module.exports = __webpack_public_path__ + "static/media/enlarge.89eb975e.svg";